import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '@jht/brand-components';
import { TranslateModule } from '@jht/brand-translate';

import { LanguageSelectorComponent } from './language-selector.component';

@NgModule({
    declarations: [LanguageSelectorComponent],
    imports: [CommonModule, ComponentsModule, RouterModule, TranslateModule],
    exports: [LanguageSelectorComponent],
})
export class LanguageSelectorModule {}
